import styled from 'styled-components';
import { border1, green, whitesmoke } from '../../utils/style/colors';

export const AssigneePopoverLayout = styled('div')`
  display: flex;
  flex-wrap: nowrap;
  width: 27rem;
  max-width: min(27rem, calc(100vw - 16px));

  @media (max-width: 500px) {
    width: auto;
    max-width: calc(100vw - 16px);
    flex-wrap: wrap;
  }
`;

export const AssigneeContentWrapper = styled('div')`
  width: 13rem;
  @media (max-width: 500px) {
    max-width: 10rem;
  }
  white-space: pre-wrap;
  text-align: center;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`;

export const AssingeeHeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 0.5rem auto;
`;

export const AssingeeHeaderAction = styled.div`
  display: flex;
  align-items: flex-end;
  gap: 0.5rem;
`;

export const PSmallMargin = styled('p')`
  margin-block-start: 0.2em;
  margin-block-end: 0.2em;
`;
export const HistoryContainer = styled('div')`
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  max-height: min(32rem, 50vh);
  width: 13rem;
  flex: 1 1 auto;
  min-width: 0;
  border: ${border1};
  border-radius: 10px;
  margin-inline-start: 1rem;
  overflow-x: auto;
  overflow-y: auto;
  overflow-y: overlay;

  @media (max-width: 500px) {
    margin-inline-start: 0.2rem;
  }
`;

export const AssignmentHistoryBody = styled('p')`
  white-space: pre-wrap;
  border-radius: 10px;
  background: ${whitesmoke};
  display: inline-block;
  font-size: 0.8rem;
  align-items: stretch;
  max-width: 100%;
  min-width: 0;
  width: 100%;
  box-sizing: border-box;
  font-weight: 500;
  line-height: 2rem;
  margin: 3px;
  padding: 0 0.5rem;
  transition: 0.3s all ease;
  border: ${border1};
  :hover {
    border: ${border1};
  }

  @media (max-width: 500px) {
    max-width: 9rem;
    min-width: 9rem;
  }
`;

export const AssignmentHistoryDate = styled('span')`
  font-size: 10px;
  display: flex;
  flex-direction: column;
`;
export const AssignmentHistoryProgress = styled('span')`
  border-radius: 15px;
  background: ${green};
  color: var(--exact-white);
  display: inline-flex;
  font-size: 0.8rem;
  align-items: center;
  font-weight: 500;
  justify-content: center;
  line-height: 2rem;
  height: 30px;
  min-width: 40px;
  margin: 3px;
  padding: 0 0.5rem;
  transition: 0.3s all ease;
  border: ${border1};
`;

export const AddDateContainer = styled('div')`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-end;
`;

export const ProgressHistoryStatusInfo = styled.div``;
